import React, { useState } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';

import { MediaSourcePicker } from './MediaSourcePicker';
import { MotionControls } from './MotionControls';
import { buildExtend } from './buildRequests';
import type { VideoPanelProps } from './panelTypes';
import type { MediaSource } from '../../../services/mediaSourceService';

/** Lengthen an existing clip (A-F5). */
export const ExtendPanel: React.FC<VideoPanelProps> = ({
  controls,
  onControlsChange,
  onSubmit,
  isRendering,
}) => {
  const [source, setSource] = useState<MediaSource | null>(null);
  const [prompt, setPrompt] = useState('');
  const canSubmit = !!source && !isRendering;

  return (
    <Stack spacing={1.5}>
      <MediaSourcePicker kind="video" label="Clip to extend" value={source} onChange={setSource} disabled={isRendering} />
      <TextField
        label="Prompt (optional)"
        value={prompt}
        onChange={e => setPrompt(e.target.value)}
        size="small"
        fullWidth
      />
      <MotionControls kind="Extend" value={controls} onChange={onControlsChange} />
      {!source && (
        <Typography variant="caption" color="text.secondary">
          Upload a clip or choose one from your library.
        </Typography>
      )}
      <Button
        variant="contained"
        disabled={!canSubmit}
        onClick={() => onSubmit('Extend', buildExtend(source!.assetId, prompt, controls))}
      >
        {isRendering ? 'Rendering…' : 'Extend clip'}
      </Button>
    </Stack>
  );
};
